import HamburgerMenu from './lib/menu';
import RecipeCarousel from './lib/recipe-carousel';
import { VideoPlayer } from './lib/video';

import './scss/core.scss';

HamburgerMenu.createFromSelectors('#hamburger', '#popup-menu', '#header');
RecipeCarousel.createFromSelector('.js-recipes-carousel');
VideoPlayer.createFromSelector('.js-video-player');
